import { API_ROUTES_FOR_AXIOS } from '../constants/ApiRoutes';
import { axiosInstance } from '../constants/axiosInstance';
import { ApiResponse } from 'src/types/commonResponseTypes';
import { AchievementStatus } from 'src/types/achievementEngine';
import { handleError } from 'src/utils/commonErrorUtils';

export const getAchievementStatuses = async (
  tzOffset: string,
): Promise<ApiResponse<AchievementStatus[]>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['getAchievementStatuses'](tzOffset);
    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};
